<template>
  <add v-if="valueName == 'add'" />
  <add-box v-else-if="valueName == 'add_box'" />
  <add-circle v-else-if="valueName == 'add_circle'" />
  <add-circle-outline v-else-if="valueName == 'add_circle_outline'" />
  <amp-stories v-else-if="valueName == 'amp_stories'" />
  <archive v-else-if="valueName == 'archive'" />
  <attribution v-else-if="valueName == 'attribution'" />
  <backspace v-else-if="valueName == 'backspace'" />
  <ballot v-else-if="valueName == 'ballot'" />
  <biotech v-else-if="valueName == 'biotech'" />
  <block v-else-if="valueName == 'block'" />
  <calculate v-else-if="valueName == 'calculate'" />
  <clear v-else-if="valueName == 'clear'" />
  <content-copy v-else-if="valueName == 'content_copy'" />
  <content-cut v-else-if="valueName == 'content_cut'" />
  <content-paste v-else-if="valueName == 'content_paste'" />
  <create v-else-if="valueName == 'create'" />
  <delete-sweep v-else-if="valueName == 'delete_sweep'" />
  <drafts v-else-if="valueName == 'drafts'" />
  <dynamic-feed v-else-if="valueName == 'dynamic_feed'" />
  <file-copy v-else-if="valueName == 'file_copy'" />
  <filter-list v-else-if="valueName == 'filter_list'" />
  <flag v-else-if="valueName == 'flag'" />
  <font-download v-else-if="valueName == 'font_download'" />
  <forward v-else-if="valueName == 'forward'" />
  <gesture v-else-if="valueName == 'gesture'" />
  <how-to-reg v-else-if="valueName == 'how_to_reg'" />
  <how-to-vote v-else-if="valueName == 'how_to_vote'" />
  <inbox v-else-if="valueName == 'inbox'" />
  <insights v-else-if="valueName == 'insights'" />
  <ic-link v-else-if="valueName == 'link'" />
  <link-off v-else-if="valueName == 'link_off'" />
  <low-priority v-else-if="valueName == 'low_priority'" />
  <mail v-else-if="valueName == 'mail'" />
  <markunread v-else-if="valueName == 'markunread'" />
  <move-to-inbox v-else-if="valueName == 'move_to_inbox'" />
  <next-week v-else-if="valueName == 'next_week'" />
  <outlined-flag v-else-if="valueName == 'outlined_flag'" />
  <policy v-else-if="valueName == 'policy'" />
  <push-pin v-else-if="valueName == 'push_pin'" />
  <redo v-else-if="valueName == 'redo'" />
  <remove v-else-if="valueName == 'remove'" />
  <remove-circle v-else-if="valueName == 'remove_circle'" />
  <remove-circle-outline v-else-if="valueName == 'remove_circle_outline'" />
  <reply v-else-if="valueName == 'reply'" />
  <reply-all v-else-if="valueName == 'reply_all'" />
  <report v-else-if="valueName == 'report'" />
  <report-gmailerrorred v-else-if="valueName == 'report_gmailerrorred'" />
  <report-off v-else-if="valueName == 'report_off'" />
  <save v-else-if="valueName == 'save'" />
  <save-alt v-else-if="valueName == 'save_alt'" />
  <select-all v-else-if="valueName == 'select_all'" />
  <send v-else-if="valueName == 'send'" />
  <sort v-else-if="valueName == 'sort'" />
  <square-foot v-else-if="valueName == 'square_foot'" />
  <text-format v-else-if="valueName == 'text_format'" />
  <unarchive v-else-if="valueName == 'unarchive'" />
  <undo v-else-if="valueName == 'undo'" />
  <waves v-else-if="valueName == 'waves'" />
  <weekend v-else-if="valueName == 'weekend'" />
  <where-to-vote v-else-if="valueName == 'where_to_vote'" />
</template>

<script>
import Add from "@/components/Icons/Content/Add";
import AddBox from "@/components/Icons/Content/AddBox";
import AddCircle from "@/components/Icons/Content/AddCircle";
import AddCircleOutline from "@/components/Icons/Content/AddCircleOutline";
import AmpStories from "@/components/Icons/Content/AmpStories";
import Archive from "@/components/Icons/Content/Archive";
import Attribution from "@/components/Icons/Content/Attribution";
import Backspace from "@/components/Icons/Content/Backspace";
import Ballot from "@/components/Icons/Content/Ballot";
import Biotech from "@/components/Icons/Content/Biotech";
import Block from "@/components/Icons/Content/Block";
import Calculate from "@/components/Icons/Content/Calculate";
import Clear from "@/components/Icons/Content/Clear";
import ContentCopy from "@/components/Icons/Content/ContentCopy";
import ContentCut from "@/components/Icons/Content/ContentCut";
import ContentPaste from "@/components/Icons/Content/ContentPaste";
import Create from "@/components/Icons/Content/Create";
import DeleteSweep from "@/components/Icons/Content/DeleteSweep";
import Drafts from "@/components/Icons/Content/Drafts";
import DynamicFeed from "@/components/Icons/Content/DynamicFeed";
import FileCopy from "@/components/Icons/Content/FileCopy";
import FilterList from "@/components/Icons/Content/FilterList";
import Flag from "@/components/Icons/Content/Flag";
import FontDownload from "@/components/Icons/Content/FontDownload";
import Forward from "@/components/Icons/Content/Forward";
import Gesture from "@/components/Icons/Content/Gesture";
import HowToReg from "@/components/Icons/Content/HowToReg";
import HowToVote from "@/components/Icons/Content/HowToVote";
import Inbox from "@/components/Icons/Content/Inbox";
import Insights from "@/components/Icons/Content/Insights";
import IcLink from "@/components/Icons/Content/IcLink";
import LinkOff from "@/components/Icons/Content/LinkOff";
import LowPriority from "@/components/Icons/Content/LowPriority";
import Mail from "@/components/Icons/Content/Mail";
import Markunread from "@/components/Icons/Content/Markunread";
import MoveToInbox from "@/components/Icons/Content/MoveToInbox";
import NextWeek from "@/components/Icons/Content/NextWeek";
import OutlinedFlag from "@/components/Icons/Content/OutlinedFlag";
import Policy from "@/components/Icons/Content/Policy";
import PushPin from "@/components/Icons/Content/PushPin";
import Redo from "@/components/Icons/Content/Redo";
import Remove from "@/components/Icons/Content/Remove";
import RemoveCircle from "@/components/Icons/Content/RemoveCircle";
import RemoveCircleOutline from "@/components/Icons/Content/RemoveCircleOutline";
import Reply from "@/components/Icons/Content/Reply";
import ReplyAll from "@/components/Icons/Content/ReplyAll";
import Report from "@/components/Icons/Content/Report";
import ReportGmailerrorred from "@/components/Icons/Content/ReportGmailerrorred";
import ReportOff from "@/components/Icons/Content/ReportOff";
import Save from "@/components/Icons/Content/Save";
import SaveAlt from "@/components/Icons/Content/SaveAlt";
import SelectAll from "@/components/Icons/Content/SelectAll";
import Send from "@/components/Icons/Content/Send";
import Sort from "@/components/Icons/Content/Sort";
import SquareFoot from "@/components/Icons/Content/SquareFoot";
import TextFormat from "@/components/Icons/Content/TextFormat";
import Unarchive from "@/components/Icons/Content/Unarchive";
import Undo from "@/components/Icons/Content/Undo";
import Waves from "@/components/Icons/Content/Waves";
import Weekend from "@/components/Icons/Content/Weekend";
import WhereToVote from "@/components/Icons/Content/WhereToVote";

export default {
  components: {
    Add,
    AddBox,
    AddCircle,
    AddCircleOutline,
    AmpStories,
    Archive,
    Attribution,
    Backspace,
    Ballot,
    Biotech,
    Block,
    Calculate,
    Clear,
    ContentCopy,
    ContentCut,
    ContentPaste,
    Create,
    DeleteSweep,
    Drafts,
    DynamicFeed,
    FileCopy,
    FilterList,
    Flag,
    FontDownload,
    Forward,
    Gesture,
    HowToReg,
    HowToVote,
    Inbox,
    Insights,
    IcLink,
    LinkOff,
    LowPriority,
    Mail,
    Markunread,
    MoveToInbox,
    NextWeek,
    OutlinedFlag,
    Policy,
    PushPin,
    Redo,
    Remove,
    RemoveCircle,
    RemoveCircleOutline,
    Reply,
    ReplyAll,
    Report,
    ReportGmailerrorred,
    ReportOff,
    Save,
    SaveAlt,
    SelectAll,
    Send,
    Sort,
    SquareFoot,
    TextFormat,
    Unarchive,
    Undo,
    Waves,
    Weekend,
    WhereToVote,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
